import { Injectable } from '@angular/core';
import { EnvDomainVariables } from './env.service';
@Injectable({
  providedIn: 'root',
})
export class EnvMagellanProdService {
  getDomainInfo(): EnvDomainVariables {
    return {
       _enableErrorLogging: false,
      _enableRefreshToken: false,
       isMagellan: '1',
       _env: 'magellan-prod',
       _apiUrl: 'https://app2-api.p-cis.com/api/',
       _production: true,
       _redirectUri: 'https://app2-login.p-cis.com/',
       _responseType: 'token id_token',
       _issuer:
         'https://magellanprodadb2c.b2clogin.com/d67f2480-16ef-4641-97e2-1c89f12aeca0/v2.0/',
       _strictDiscoveryDocumentValidation: false,
      _tokenEndpoint:
        'https://magellanprodadb2c.b2clogin.com.b2clogin.com/magellanprodadb2c.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1_signin',
       _loginUrl:
         'https://magellanprodadb2c.b2clogin.com/magellanprodadb2c.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_Signin',
       _clientId: 'd851d2b7-becd-4acd-b501-ba39b52e53c6',
      _scope:
        'openid profile https://magellanprodadb2c.onmicrosoft.com/api/magellan.read',
       _skipIssuerCheck: true,
       _clearHashAfterLogin: true,
       _oidc: true,
      _logoutUrl:
        'https://magellanprodadb2c.b2clogin.com/magellanprodadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/logout?post_logout_redirect_uri=https://app2-login.p-cis.com/',
      _signInURL:
        "https://magellanprodadb2c.b2clogin.com/magellanprodadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_signin_signup_frp",
      _signInURLSSO:
        "https://magellanprodadb2c.b2clogin.com/magellanprodadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO",
      _adb2cTenantUrl:
        'https://magellanprodadb2c.b2clogin.com/magellanprodadb2c.onmicrosoft.com/oauth2/v2.0/',
      _magicLink:
        'https://magellanprodadb2c.b2clogin.com/magellanprodadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_WITH_EMAIL',
      _authEndpoint: 'https://magellanprodadb2c.b2clogin.com/magellanprodadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/authorize',
      _magicLinkScope : 'https://magellanprodadb2c.b2clogin.com/magellanprodadb2c.onmicrosoft.com/B2C_1A_SIGNIN_WITH_EMAIL/oauth2/v2.0/authorize',
      _launchDarklyClientId: '69120006711aa209b78d9ab0',
      _intercomAppId: 'bqgvwybf'
    };
  }
}
